import React, { lazy, Suspense } from 'react';
// Router
import { createBrowserRouter } from 'react-router-dom';
// Page
const Estamp = lazy(() => import('../Components/Pages/Stamps/Estamp'));
const UploadFile = lazy(() => import('../Components/Pages/UploadFile/UploadFile'));
const Registration = lazy(() => import('../Components/Pages/Registration/Registration'));
const DashBoard = lazy(() => import('../Components/Pages/Dashboard/dashboard'));
const StampForm = lazy(() => import('../Components/Pages/Stamps/StampForm'));
const UserAndBranchDashboard = lazy(() => import('../Components/Pages/UAMDashboard/UserAndBranchDashboard'));
const Edit = lazy(() => import('../Components/Pages/Edit/Edit'));
const Test = lazy(() => import('../Components/Pages/Test_API/Test'));
const Profile = lazy(() => import('../Components/Pages/Profile/Profile'));
const EditOrgnaization = lazy(() => import('../Components/Pages/Profile/EditOrgnaization'));
const EditPersonalInfo = lazy(() => import('../Components/Pages/Profile/EditPersonalInfo'));
const Recipientsinfo = lazy(() => import('../Components/Pages/Recipientsinfo'));
const Template = lazy(() => import('../Components/Pages/Template/Template'));
const TemplatePreview = lazy(() => import('../Components/Pages/TemplatePreview/TemplatePreview'));
const ErrorPage = lazy(() => import('../Components/Pages/404ErrorPage/ErrorPage'));
const Login = lazy(() => import('../Components/Pages/Login/Login'));
const ForgetPassword = lazy(() => import('../Components/Pages/Login/ForgetPassword'));
const Enquiry = lazy(() => import('../Components/Pages/Enquiry/Enquiry'));
const ResetPassword = lazy(() => import('../Components/Pages/Login/ResetPassword'));
const Settings = lazy(() => import('../Components/Pages/Settings/Settings'));
const OverViewDashboard = lazy(() => import('../Components/Pages/StatisticOverview/OverViewDashboard'));
const LandingPage = lazy(() => import('../Components/Pages/LandingPage/LandingPage'));
const WalletHistory = lazy(() => import('../Components/Pages/WalletHistory/WalletHistory'));
const Wallet = lazy(() => import('../Components/Pages/Wallet/Wallet'));
const Bulk_eSign = lazy(() => import('../Components/Pages/Bulk-eSign/Bulk-eSign'));
const SignUp = lazy(() => import('../Components/Pages/IndividualUser/SignUp'));
const NewEsign = lazy(() => import('../Components/Pages/NewEsign/NewEsign'));
const Signature = lazy(() => import('../Components/Pages/Signature'));
import MainLayout from '../Components/Layouts/main_layout';

// Constant
import { dashboardColumnData, dashboardNavData } from '../Assets/Constants/json_constants';
import UnProtectedLayout from '../Components/Layouts/UnProtectedLayout';
import Approval from '../Components/Pages/Redirect';
import Inventory from '../Components/Pages/Inventory';
import ErrorBoundary from '../Components/Pages/ErrorBoundary';
import BulkInventory from '../Components/Pages/BulkInventory';
import NoPermission from '../Components/Pages/NoPermission';

export default createBrowserRouter([
  {
    element: (
      <ErrorBoundary>
        <MainLayout />
      </ErrorBoundary>
    ),
    children: [
      { path: '/inventory/:stateId/:denomination', element: <Inventory /> },
      { path: '/bulk-inventory/:stateId/:denomination', element: <BulkInventory /> },
      { path: '/edit', element: <Edit /> },
      { path: '/template', element: <Template /> },
      { path: '/templatepreview', element: <TemplatePreview /> },
      { path: '/profile', element: <Profile /> },
      { path: '/personalInfo', element: <EditPersonalInfo /> },
      { path: '/organizationInfo', element: <EditOrgnaization /> },
      { path: '/recipient', element: <Recipientsinfo /> },
      { path: '/uploadfile', element: <UploadFile /> },
      { path: '/estamp', element: <Estamp /> },
      { path: '/no-permission', element: <NoPermission /> },
      {
        path: '/dashboard',
        element: <DashBoard columns={dashboardColumnData} navs={dashboardNavData} />
      },
      { path: '/wallet', element: <Wallet /> },
      { path: '/walletHistory', element: <WalletHistory /> },
      { path: '/stamp-form', element: <StampForm /> },
      { path: '/uam', element: <UserAndBranchDashboard /> },
      { path: '/test', element: <Test /> },
      { path: '/signature', element: <Signature /> },
      { path: '/estamp', element: <Estamp /> },
      { path: '/uploadfile', element: <UploadFile /> },
      { path: '/registration', element: <Registration /> },
      { path: '/setting', element: <Settings /> },
      { path: '/reset-password-profile', element: <ResetPassword /> },
      { path: '/wallet', element: <Wallet /> },
      {
        path: '/statistics',
        element: <OverViewDashboard />
      },
      {
        path: '/bulk-esign',
        element: <Bulk_eSign />
      },
      {
        path: '/new-esign',
        element: <NewEsign />
      }
    ]
  },
  {
    element: (
      <ErrorBoundary>
        <UnProtectedLayout />
      </ErrorBoundary>
    ),
    children: [
      { path: '/', element: <LandingPage /> },
      { path: '/reset-password', element: <ResetPassword /> },
      { path: '/forget-password', element: <ForgetPassword /> },
      { path: '/login', element: <Login /> },
      { path: '/enquiry', element: <Enquiry /> },
      { path: '/signup', element: <SignUp /> }
    ]
  },
  { path: 'approvals/:page/:id', element: <Approval /> },
  {
    path: '*',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ErrorPage />
      </Suspense>
    )
  }
]);
